module.exports = __webpack_public_path__ + "static/media/400139_02.3101b113.png";